import React from "react";
import useEvolution from "../utils/useEvolution";

export const Thumbnail = ({ name }) => {
  const { pokemonData, loading, error } = useEvolution(name);

  if (loading) return <p>loading {name}...</p>;
  if (error) return <p> {error}</p>;
  if (!pokemonData) return null;

  const animatedImagen =
    pokemonData.sprites?.versions?.["generation-v"]?.["black-white"]?.animated
      ?.front_default ||
    pokemonData.sprites?.versions?.["generation-v"]?.["black-white"]
      ?.front_default;
  return (
    <div className="poke-animated-container">
      {animatedImagen ? (
        <img
          alt={`${name}animated`}
          title={`${name}`}
          src={animatedImagen}
          className="single-pok-evolution"
        />
      ) : (
        <p> no available</p>
      )}
    </div>
  );
};

export default Thumbnail;
